import { Component } from '@angular/core';

@Component({
  selector: 'root-app-empty-route',
  template: '',
  standalone: false,
})
export class EmptyRouteComponent {}
